/**
 * LandingLanguageSwitcher — DE/EN-Umschalter für die öffentliche Landingpage
 * (suite#31 Teil 2, deckt auch web#7 ab).
 *
 * Nutzt denselben Mechanismus wie der Umschalter in den Settings
 * (routes/_auth.settings.tsx): i18n.changeLanguage() direkt, kein eigener
 * State — i18next-browser-languagedetector persistiert automatisch nach
 * localStorage (Key: LANGUAGE_STORAGE_KEY, siehe i18n/index.ts).
 */
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGUAGES, markLanguageExplicit } from '../../i18n'

export function LandingLanguageSwitcher() {
  const { i18n } = useTranslation()
  const current = i18n.resolvedLanguage ?? i18n.language

  return (
    <div className="lang-switch" role="group" aria-label="Sprache">
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang-switch__btn${current === lng ? ' lang-switch__btn--active' : ''}`}
          aria-pressed={current === lng}
          data-testid={`lang-switch-${lng}`}
          onClick={() => {
            markLanguageExplicit()
            i18n.changeLanguage(lng)
          }}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
